export default __webpack_public_path__ + "static/media/grad_element.75694c94.png";